import { render, staticRenderFns } from "./LmCodificatorsBuilderNewOrEdit.vue?vue&type=template&id=1237822c&scoped=true"
import script from "./LmCodificatorsBuilderNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmCodificatorsBuilderNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./LmCodificatorsBuilderNewOrEdit.vue?vue&type=style&index=0&id=1237822c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1237822c",
  null
  
)

export default component.exports